export const NOT_SAVED_INTER_PAGE_WARNING = "not-saved-warning-inter-page";
export const NOT_SAVED_APP_EXIT_WARNING = "not-saved-warning-app-exit";
export const CREATE_CLAIMS_COVERAGE_LIST = "claims-merger/create-coverage-list";
export const APP_BAR_ISSUE_FEEDBACK_BUTTON = "app-bar.Issue-Feedback-button";
export const APP_BAR_ISSUE_FEEDBACK_IN_MENU = "app-bar.Issue-Feedback";
export const SUB_STAT_REPORT_SHOW_PROGRAM_REFERENCE =
  "SubmissionStatusReport.show-program-reference";
export const SUB_STAT_REPORT_SHOW_LAYER_REFERNCE =
  "SubmissionStatusReport.show-layer-reference";
export const REVIEW_REPORTS_SHOW_ALL_VALUES_IN_FILTERS =
  "ReviewReports.show-all-values-in-filters";
export const SUBMISSION_STATUS_USE_V3_REPORT =
  "submission-review.use-v3-report";
export const SOV_DOWNLOAD_BUTTON_ENABLED = "SOV-download-enabled";
export const SOV_TEMPLATE_DOWNLOAD_BUTTON_ENABLED =
  "input.sov.template.download.button";
export const CAT_EXPOSURES_UPLOAD_ENABLED = "input.cat_exposures.upload";
export const DYNAMIC_AUTO_COMPLETE = "ui/dynamic-auto-complete";
export const INCLUDE_AGGREGATE_LOSS_BY_LINE =
  "ui/include-aggregate-loss-by-line";
export const USE_CLAIMS_AI_PARSING = "claims-ai-parsing";
export const USE_AI_AGENTS_COLUMN_MAPPING = "use-ai-agents-column-mapping";
export const USE_STREAMING_FOR_CLAIMS_AI_PARSING =
  "use-streaming-for-claims-ai-parsing";
export const AI_PDF_EXTRACTION = "ai-pdf-extraction";
export const AI_CLAIMS_MATCH = "ai-claims-match";
export const RUN_AI_CLAIMS_MATCH_ON_LOAD = "run-ai-claims-match-on-load";
export const AI_CLAIMS_DUPLICATE_DETECTION = "ai-claims-duplicate-detection";
export const RENEWAL_FILTER_IS_VISIBLE =
  "submission-review.renewal-filter-is-visible";
export const DASHBOARD_CALENDAR_MONTH_BUTTONS =
  "submission-review.calendar-month-buttons";
export const DISPLAY_TEMPLATES_SUMMARY_BUTTON =
  "<Templates>.display-templates-summary-button";
export const NOTES_ABOVE_SUBJECTIVITIES =
  "<Templates>.notesAboveSubjectivities";
export const USE_PRO_RATA_ADD_RETURN_CALCULATOR =
  "ui-premium-adjust-use-pro-rata-additional-return-calculator";
export const SOV_GRID_COPY_CELLS_ENABLED = "sov-grid-copy-cells-enabled";
export const TOWER_PRICING_SIR_COPY_ENABLED =
  "pricing.towerPricing.includeSir.copyToAll";
export const TOWER_PRICING_HIGHLIGHT_OWN_LAYERS =
  "pricing.towerPricing.highlightOwnLayers";
export const PROGRAM_UNDERWRITER_ASSISTANT =
  "input.program.insuredDetail.underwriterAssistant";
export const AI_PDF_VIEWER_ALLOW_EXCEL_DOWNLOADS =
  "ai-pdf-viewer-allow-excel-downloads";
export const PRICING_ENABLE_SPLIT_UW_LOAD = "pricing-enable-split-uw-load";
export const USE_PING_SOV_EXTRACTION = "use-ping-sov-extraction";
export const EXPOSURE_ROW_REORDER = "input.exposure.rowReorder";
export const SUBMISSION_FILE_UPLOAD_DRAWER = "submission-file-upload-drawer";
export const SUBMISSION_TRIAGE = "submission-triage";
export const AUTO_TRIAGE = "auto-triage";
export const AI_CARRY_FORWARD_PAGE = "ai-carry-forward-page";
export const AI_CARRY_FORWARD_CONFIDENCE = "ai-carry-forward-confidence";
export const AI_CARRY_FORWARD_EDIT = "ai-carry-forward-edit";
export const AI_CARRY_FORWARD_AGENT_SEARCH = "ai-carry-forward-agent-search";
export const AI_CARRY_FORWARD_ALL_DOCUMENTS = "ai-carry-forward-all-documents";
export const TOWER_SIR_SUMMARY_DISPLAY = "tower-sir-summary-display";
export const SUMMARY_PRICING_RESULTS_TOGGLE = "summary-pricing-results-toggle";
export const INSURED_ADDRESS_COMPONENTS =
  "input.program.insuredDetail.insuredAddressComponents";
export const BROKER_ADDRESS_COMPONENTS =
  "input.program.broker.addressComponents";
export const MAILING_ADDRESS = "input.program.insuredDetail.mailingAddress";
export const INSURED_ADDRESS_AUTO_PARSE =
  "input.program.insuredDetail.insuredAddressAutoParse";
export const SIC_CODE_INDUSTRY_SUGGESTION =
  "input.program.sicCodeIndustrySuggestion";
export const LEGACY_THEME = "ui/legacyTheme";
export const ENDORSEMENT_ALLOW_SKIP_COUNT = "endorsement_allow_skip_count";
export const ENDORSEMENT_SORT_ORDER = "input.endorsements.sortOrder";
export const ENDORSEMENT_AUTO_TRIA_FORMS = "input.endorsements.autoTriaForms";
export const TRIA_STATUS_INCLUDED_GROSS_UP_OPTION =
  "input.layers.triaStatusIncludedGrossUp";
export const SHOW_AI_FILE_SELECTION_LABELS = "show-ai-file-selection-labels";
export const SEARCH_HELP_POPOVER = "search.help-popover";
export const SEARCH_CREATE_FROM_NO_MATCHES = "search.createFromNoMatches";
export const ENABLE_AGGREGATE_COLUMN_GENERATION =
  "REPORTS-V3-enable-aggregate-column-generation";
export const REPORTS_V3_ALLOW_IMPORT_EXPORT =
  "reports_v3.allow_import_and_export";
export const REPORTS_V3_ALLOW_MULTI_TABLE_REPORTS =
  "reports_v3.allow_multi_table_reports";
export const REPORTS_V3_ALLOW_AS_AT = "reports_v3.allow_as_at";
export const REPORTS_V3_REVIEW_SCORECARD = "reports_v3.review_scorecard";
export const POLICY_MANAGER = "<Templates>.policyManager";
export const AUTO_STATUS_ON_DOCUMENT_ISSUE = "ui/autoStatusOnDocumentIssue";
export const PRICING_LOSS_RATING = "pricing.lossRating";
export const PRICING_XS_RATING = "pricing.xsRating";
export const LAYER_PRICING_COMPACT_LAYOUT = "ui/layerPricingCompactLayout";
export const TEMPLATE_REQUESTS_EDIT_FLOW_V2 = "templateRequests.editFlowV2";
export const GL_PRICING_CLASSIFICATIONS =
  "pricing.glPricing.glClassificationsTable";
export const SPREADSHEET_BASED_PRICING = "pricing.SpreadsheetBasedPricing";
export const COVERAGE_NOTES = "coverage-notes";
export const TEMPLATE_OVERRIDE_ALLOW_PDF = "<Templates>.allowPdfOverride";
export const TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT =
  "<Templates>.downloadFilledWordDocument";

const flags = {
  visible: [
    { tag: SOV_TEMPLATE_DOWNLOAD_BUTTON_ENABLED },
    {
      tag: SUBMISSION_FILE_UPLOAD_DRAWER,
      displayName: "Submission File Upload Drawer",
    },
    {
      tag: SUBMISSION_TRIAGE,
      displayName: "Submission Triage",
    },
    {
      tag: AUTO_TRIAGE,
      displayName: "Auto Triage After Ingestion",
    },
    {
      tag: AI_CARRY_FORWARD_PAGE,
      displayName: "AI Ingestion > Carry Forward Review Page",
    },
    {
      tag: AI_CARRY_FORWARD_CONFIDENCE,
      displayName: "AI Ingestion > Carry Forward: Show Confidence Column",
    },
    {
      tag: AI_CARRY_FORWARD_EDIT,
      displayName: "AI Ingestion > Carry Forward: Allow Value Overrides",
    },
    {
      tag: AI_CARRY_FORWARD_AGENT_SEARCH,
      displayName: "AI Ingestion > Carry Forward: Agent Search Fields",
    },
    {
      tag: AI_CARRY_FORWARD_ALL_DOCUMENTS,
      displayName: "AI Ingestion > Carry Forward: Attach All Documents",
    },
    { tag: "persistentFullWidth" },
    { tag: "saveConflictAlert" },
    { tag: "review.metrics" },
    { tag: "review.peer-review", displayName: "Dashboard > Peer Review" },
    {
      tag: SUBMISSION_STATUS_USE_V3_REPORT,
      displayName: "Submission Status > Use V3 Report",
    },
    { tag: "generatePolicyNumber.lockUntilBound" },
    { tag: "generatePolicyNumber.tooltip" },
    { tag: "offlineBanner" },
    {
      tag: "submissionStatus.editable",
      priority: 100,
      displayName: "submissionStatus.editable",
    },
    {
      tag: "input.fx_rates",
      priority: 100,
      displayName: "input.fx_rates",
    },
    {
      tag: "input.cat_exposures",
      priority: 100,
      displayName: "input.cat_exposures",
    },
    {
      tag: "input.gl_exposures",
      priority: 440,
      displayName: "Tab > Input > GL Exposures",
    },
    {
      tag: "input.auto_exposure_rating",
      priority: 440,
      displayName: "Tab > Input > Auto Exposure Rating",
    },
    {
      tag: "input.loss_rating",
      priority: 440,
      displayName: "Tab > Input > Loss Rating",
    },
    {
      tag: CAT_EXPOSURES_UPLOAD_ENABLED,
      priority: 100,
      displayName: "Input > Cat Exposures: Excel Upload",
    },
    {
      tag: EXPOSURE_ROW_REORDER,
      priority: 100,
      displayName: "Input > Exposure: Row Reordering",
    },
    {
      tag: ENDORSEMENT_SORT_ORDER,
      priority: 100,
      displayName: "Policy > Endorsements: Sort by sortOrder",
    },
    {
      tag: ENDORSEMENT_AUTO_TRIA_FORMS,
      priority: 100,
      displayName: "Policy > Endorsements: Auto TRIA forms from TRIA status",
    },
    {
      tag: "input.coverages",
      priority: 100,
      displayName: "input.coverages",
    },
    { tag: "input.layers" },
    {
      tag: TRIA_STATUS_INCLUDED_GROSS_UP_OPTION,
      priority: 100,
      displayName: "Layer Pricing: offer Included (Gross Up) TRIA status",
    },
    {
      tag: "input.coverage.layers.deleteLayer",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Delete Column",
    },
    {
      tag: "input.coverage.layers.status",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Status Column",
    },
    {
      tag: "input.coverage.layers.limit",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Limit Column",
    },
    {
      tag: "input.coverage.layers.attachment",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Attachment Column",
    },
    {
      tag: "input.coverage.layers.shareOfLine",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Share of Line Column",
    },
    {
      tag: "input.coverage.layers.brokerage",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Brokerage Column",
    },
    {
      tag: "input.coverage.layers.targetPremium",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Target Premium Column",
    },
    {
      tag: "input.coverage.layers.perils",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Perils Column",
    },
    {
      tag: "input.coverage.layers.scheme",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Scheme Column",
    },
    {
      tag: "input.coverage.layers.reference",
      priority: 100,
      displayName: "Input > Coverage > Layers Table: Reference Column",
    },
    {
      tag: "input.coverage.perils",
      priority: 100,
      displayName: "Input > Coverage > Perils Coverage Section",
    },
    {
      tag: "input.coverage.cat",
      priority: 100,
      displayName: "Input > Coverage > Cat Coverages Section",
    },
    {
      tag: "input.coverage.noncat",
      priority: 100,
      displayName: "Input > Coverage > Non-Cat Coverages Section",
    },
    {
      tag: "<DnfLayerPricing>.layerPricing.menu.changePricingModel",
      priority: 100,
      displayName: "<DnfLayerPricing>.layerPricing.menu.changePricingModel",
    },
    {
      tag: "input.coverage.binary",
      priority: 100,
      displayName: "Input > Coverage > Binary Coverages Section",
    },
    {
      tag: "input.coverage.primaryTower",
      priority: 100,
      displayName: "Input > Coverage > Use The Shared Tower Component",
    },
    { tag: "<ActiveLayerEditor>.auditable" },
    { tag: "<ActiveLayerEditor>.auditFrequency" },
    { tag: "<ActiveLayerEditor>.dateReceived" },
    { tag: "<ActiveLayerEditor>.quoteDate" },
    { tag: "<ActiveLayerEditor>.transaction" },
    { tag: "<ActiveLayerEditor>.oac" },
    { tag: "<ActiveLayerEditor>.expenses" },
    { tag: "<ActiveLayerEditor>.includeSir" },
    { tag: "<ActiveLayerEditor>.includeSirById" },
    {
      tag: "<ActiveLayerEditor>.aggregateLimit",
      priority: 100,
      displayName: "<ActiveLayerEditor>.aggregateLimit",
    },
    {
      tag: "<ActiveLayerEditor>.pcoAggregate",
      priority: 100,
      displayName: "<ActiveLayerEditor>.pcoAggregate",
    },
    {
      tag: "<ActiveLayerEditor>.TRIAAmount",
      priority: 100,
      displayName: "<ActiveLayerEditor>.TRIAAmount",
    },
    {
      tag: "<ActiveLayerEditor>.TRIA",
      priority: 100,
      displayName: "<ActiveLayerEditor>.TRIA",
    },
    {
      tag: "<ActiveLayerEditor>.shareOfPremiumVisible",
      priority: 100,
      displayName: "<ActiveLayerEditor>.shareOfPremiumVisible",
    },
    {
      tag: "<ActiveLayerEditor>.shareOfPremiumWithTRIA",
      priority: 100,
      displayName: "<ActiveLayerEditor>.shareOfPremiumWithTRIA",
    },
    { tag: "<ActiveLayerEditor>.puniWrap" },
    { tag: "<ActiveLayerEditor>.authorizedLimit" },
    { tag: "<ActiveLayerEditor>.premOpsPremium" },
    { tag: "<ActiveLayerEditor>.pcoPremium" },
    { tag: "<ActiveLayerEditor>.liquorPremium" },
    { tag: "<ActiveLayerEditor>.autoPremium" },
    { tag: "<ActiveLayerEditor>.chargedToTechnicalPct" },
    { tag: "<ActiveLayerEditor>.policyFee" },
    { tag: "<ActiveLayerEditor>.inspectionFee" },
    { tag: "<ActiveLayerEditor>.lossControlFee" },
    { tag: "<ActiveLayerEditor>.regionalCoverage" },
    { tag: "<ActiveLayerEditor>.perilsCoverage" },
    { tag: "<ActiveLayerEditor>.businessUnit" },
    { tag: "<ActiveLayerEditor>.isBinderIssued" },
    { tag: "<ActiveLayerEditor>.isPolicyIssued" },
    { tag: "<ActiveLayerEditor>.minimumEarnedPremium" },
    { tag: "<ActiveLayerEditor>.statusReason" },
    {
      tag: "<ActiveLayerEditor>.projectSpecificRate",
      priority: 100,
      displayName: "<ActiveLayerEditor>.projectSpecificRate",
    },
    { tag: "<ActiveLayerEditor>.grossEstLossRatio" },
    { tag: "<ActiveLayerEditor>.riskAdjustedReturnOnCapital" },
    { tag: "<ActiveLayerEditor>.layerStructure" },
    { tag: "<ActiveLayerEditor>.premiumAndShare" },
    { tag: "<ActiveLayerEditor>.costsAndMargins" },
    { tag: "<ActiveLayerEditor>.coverageAndPolicyDetails" },
    { tag: "<ActiveLayerEditor>.administrationAndReferences" },
    {
      tag: "<ActiveLayerEditor>.inceptionDate",
      priority: 100,
      displayName: "Layer Editor > Inception Date Field",
    },
    {
      tag: "inputs.lossDevelopment.exAnte",
      priority: 100,
      displayName: "inputs.lossDevelopment.exAnte",
    },
    {
      tag: "<Attachments>.rootFolder",
      priority: 100,
      displayName: "<Attachments>.rootFolder",
    },
    { tag: "<SOV>.heatmap" },
    { tag: "<Templates>.documentationNote" },
    {
      tag: NOTES_ABOVE_SUBJECTIVITIES,
      displayName: "Templates > Notes Panel Above Subjectivities",
    },
    { tag: "<Templates>.documentsIssued" },
    { tag: "<Templates>.peerReview" },
    { tag: "<Templates>.endorsements" },
    { tag: "<Templates>.fixedListEndorsements" },
    { tag: "<Templates>.termsAndConditions" },
    { tag: "<Templates>.specialConditions" },
    { tag: "<Templates>.subjectivities" },
    { tag: "<Templates>.subjectivitiesEditable" },
    { tag: "<DocumentsIssued>.quote" },
    { tag: "<DocumentsIssued>.binder" },
    { tag: "<DocumentsIssued>.policyDrafted" },
    { tag: "<DocumentsIssued>.policy" },
    { tag: "<DocumentsIssued>.puniQuote" },
    { tag: "<DocumentsIssued>.puniBinder" },
    { tag: "<DocumentsIssued>.puniPolicy" },
    { tag: "<DocumentsIssued>.followUpEmails" },
    {
      tag: "<DocumentsIssued>.policyIssuanceStatus",
      displayName: "Documents Issued > Policy Issuance Status",
    },
    {
      tag: "<DocumentsIssued>.policyIssuanceStatus.dropdown",
      displayName:
        "Documents Issued > Policy Issuance Status > Internal/External Dropdown",
    },
    {
      tag: "input.attachment.sic",
      priority: 200,
      displayName: "RRRe > SIC",
      tooltip:
        "Allows the importing of a specific type of file called a SIC which is only used in the RRRe pricing engine at the moment.",
    },
    {
      tag: "input.attachment.lossRun",
      priority: 200,
      displayName: "Insurance > Attachment Page Loss Run Button",
    },
    {
      tag: "input.claims.selfInsuredRetentions",
      priority: 100,
      displayName: "input.claims.selfInsuredRetentions",
    },
    {
      tag: "input.claims.claimsAndDeltaChart",
      priority: 100,
      displayName: "input.claims.claimsAndDeltaChart",
    },
    {
      tag: "input.claims.claimsDeltaChart",
      priority: 100,
      displayName: "input.claims.claimsDeltaChart",
    },
    {
      tag: "input.claims.claimsComparisonTable",
      priority: 100,
      displayName: "input.claims.claimsComparisonTable",
    },
    {
      tag: "input.claims.claimsLargest",
      priority: 100,
      displayName: "input.claims.claimsLargest",
    },
    {
      tag: "input.claims.inflationModelSelector",
      priority: 200,
      displayName: "Ark > Inflation Model Selector",
    },
    { tag: "input.claims.aggregatedClaimsTable" },
    { tag: "input.claims.aggregatedClaimsInput" },
    {
      tag: "input.exposure.revenueRequired",
      priority: 100,
      displayName: "input.exposure.revenueRequired",
    },
    {
      tag: "input.program.programTiv",
      priority: 100,
    },
    {
      tag: "input.program.paymentTerms",
      priority: 100,
      displayName: "input.program.paymentTerms",
    },
    {
      tag: "input.program.riskSummary",
      priority: 100,
      displayName: "input.program.riskSummary",
    },
    {
      tag: "input.program.insuredDetail",
      priority: 100,
      displayName: "input.program.insuredDetail",
    },
    {
      tag: "input.program.insuredDetail.insured",
      priority: 100,
      displayName: "input.program.insuredDetail.insured",
    },
    { tag: "input.program.insuredDetail.companySearch" },
    { tag: "input.program.insuredDetail.insuredWithSanctionsSearch" },
    { tag: "input.program.insuredDetail.nonRenewing" },
    {
      tag: "input.program.insuredDetail.multiYearDeal",
      priority: 100,
      displayName: "Program > Multi-year deal marker",
    },
    {
      tag: "input.program.insuredDetail.cancelAtFirstAnniversary",
      priority: 100,
      displayName: "Program > Cancel and rewrite at first anniversary marker",
    },
    { tag: "input.program.insuredDetail.auditable" },
    { tag: "input.program.insuredDetail.formOfBusiness" },
    {
      tag: "input.program.insuredDetail.cession",
      priority: 100,
      displayName: "Program > Reinsured, MGA and cession limits",
    },
    {
      tag: "input.program.insuredDetail.riskDescription",
      priority: 100,
      displayName: "input.program.insuredDetail.riskDescription",
    },
    {
      tag: "input.program.insuredDetail.insuredAddress",
      priority: 100,
      displayName: "input.program.insuredDetail.insuredAddress",
    },
    {
      tag: MAILING_ADDRESS,
      priority: 100,
      displayName: "input.program.insuredDetail.mailingAddress",
    },
    {
      tag: INSURED_ADDRESS_COMPONENTS,
      priority: 100,
      displayName:
        "Program > Insured Address Components (Street/City/State/Zip)",
    },
    {
      tag: "input.program.insuredDetail.insuredLogo",
      priority: 100,
      displayName: "input.program.insuredDetail.insuredLogo",
    },
    {
      tag: "input.program.insuredDetail.inception",
      priority: 100,
      displayName: "input.program.insuredDetail.inception",
    },
    {
      tag: "input.program.insuredDetail.expiration",
      priority: 100,
      displayName: "input.program.insuredDetail.expiration",
    },
    { tag: "input.program.insuredDetail.transaction" },
    { tag: "input.program.insuredDetail.effectiveDate" },
    {
      tag: "input.program.insuredDetail.njTransactionNumber",
      priority: 100,
      displayName: "Program > NJ Transaction Number",
    },
    {
      tag: "input.program.insuredDetail.effectiveExpiration",
      priority: 100,
      displayName: "Program > Effective Expiration (for policy extensions)",
    },
    {
      tag: "input.program.insuredDetail.mtaCancellationWarnings",
      priority: 100,
      displayName: "Program > MTA/Cancellation Date Warnings",
    },
    { tag: "input.program.insuredDetail.dateReceived" },
    { tag: "input.program.insuredDetail.quoteDeadline" },
    { tag: "input.program.insuredDetail.quoteDate" },
    { tag: "input.program.insuredDetail.quoteValidUntil" },
    { tag: "input.program.insuredDetail.warrantyDate" },
    { tag: "input.program.insuredDetail.status" },
    {
      tag: "input.program.insuredDetail.proRata",
      priority: 100,
      displayName: "input.program.insuredDetail.proRata",
    },
    {
      tag: "input.program.insuredDetail.reference",
      priority: 100,
      displayName: "input.program.insuredDetail.reference",
    },
    { tag: "input.program.insuredDetail.quoteReference" },
    { tag: "input.program.insuredDetail.policySummary" },
    {
      tag: "input.program.insuredDetail.preferredUnderwriter",
      displayName: "input.program.insuredDetail.preferredUnderwriter",
      priority: 100,
    },
    { tag: "input.program.insuredDetail.secondaryUnderwriter" },
    {
      tag: "input.program.insuredDetail.me-underwriter",
      priority: 100,
      displayName: "input.program.insuredDetail.me-underwriter",
    },
    {
      tag: "input.program.insuredDetail.requestedBrokerage",
      priority: 100,
      displayName: "input.program.insuredDetail.requestedBrokerage",
    },
    {
      tag: "input.program.stateOfFiling",
      priority: 100,
      displayName: "input.program.stateOfFiling",
    },

    {
      tag: "input.program.insuredDetail.brokerage",
      priority: 100,
      displayName: "input.program.insuredDetail.brokerage",
    },
    {
      tag: "input.program.insuredDetail.oac",
      priority: 100,
      displayName: "input.program.insuredDetail.oac",
    },
    {
      tag: "input.program.insuredDetail.targetProfit",
      priority: 100,
      displayName: "input.program.insuredDetail.targetProfit",
    },
    {
      tag: "input.program.insuredDetail.gnulr",
      priority: 100,
      displayName: "input.program.insuredDetail.gnulr",
    },
    {
      tag: "input.program.insuredDetail.expenses",
      priority: 100,
      displayName: "input.program.insuredDetail.expenses",
    },
    {
      tag: "input.program.insuredDetail.paymentTerms",
      priority: 100,
      displayName: "input.program.insuredDetail.paymentTerms",
    },
    {
      tag: "input.program.insuredDetail.naicsForPricing",
      priority: 100,
      displayName: "input.program.insuredDetail.naicsForPricing",
    },
    {
      tag: "input.program.insuredDetail.naicsOfCompany",
      priority: 100,
      displayName: "input.program.insuredDetail.naicsOfCompany",
    },
    {
      tag: "input.program.insuredDetail.inUsLocation",
      priority: 100,
      displayName: "input.program.insuredDetail.inUsLocation",
    },
    {
      tag: "input.program.insuredDetail.turnoverCategory",
      priority: 100,
      displayName: "input.program.insuredDetail.turnoverCategory",
    },
    {
      tag: "input.program.insuredDetail.currency",
      priority: 100,
      displayName: "input.program.insuredDetail.currency",
    },
    {
      tag: "input.program.insuredDetail.reinsurance",
      priority: 100,
      displayName: "input.program.insuredDetail.reinsurance",
    },
    {
      tag: "input.program.insuredDetail.defaultPaperProvider",
    },
    {
      tag: "input.program.insuredDetail.policyFee",
    },
    {
      tag: "input.program.insuredDetail.inspectionFee",
    },
    {
      tag: "input.program.insuredDetail.priority",
    },
    {
      tag: "input.program.statusBlock",
      priority: 100,
      displayName:
        "Program > Status (Status Override and Decline/NTU Reason above Industry Class)",
    },
    {
      tag: "input.program.industryClass",
      priority: 100,
      displayName: "input.program.industryClass",
    },
    {
      tag: "input.program.companySic",
      priority: 100,
      displayName: "input.program.companySic",
    },
    {
      tag: "input.program.productLine",
      priority: 100,
      displayName: "input.program.productLine",
    },
    {
      tag: "input.program.tags",
      priority: 100,
      displayName: "input.program.tags",
    },
    {
      tag: "input.program.modelSelector",
      priority: 100,
      displayName: "input.program.modelSelector",
    },
    {
      tag: "input.program.categoryCode",
      priority: 100,
      displayName: "input.program.categoryCode",
    },
    {
      tag: "input.program.broker",
      priority: 100,
      displayName: "input.program.broker",
    },
    {
      tag: BROKER_ADDRESS_COMPONENTS,
      priority: 100,
      displayName:
        "Program > Broker Address Components (Street/City/State/Zip)",
    },
    {
      tag: "input.program.assistant",
      priority: 100,
      displayName: "input.program.assistant",
    },
    { tag: "input.program.primaryExposure" },
    { tag: "input.program.standaloneExposure" },
    { tag: "<Print>.primaryExposure" },
    { tag: "<Print>.historicalExposuresTable" },
    { tag: "input.program.puniBroker" },
    { tag: "input.program.retailBroker" },
    { tag: "input.program.regulatoryExemptions" },
    { tag: "input.program.newYorkFreeTradeZone" },
    { tag: "input.program.deregulated" },
    {
      tag: "input.program.surplusBroker",
      priority: 100,
      displayName: "input.program.surplusBroker",
    },
    {
      tag: "input.program.producerBroker",
      priority: 100,
    },
    {
      tag: "input.program.wholesaleBroker",
      priority: 100,
    },
    {
      tag: "input.program.wholesaleBroker.switchable",
      priority: 100,
    },
    { tag: "input.program.insuredDetail.surplusBroker" },
    {
      tag: "input.program.duns",
      priority: 100,
      displayName: "input.program.duns",
    },
    {
      tag: "input.program.share",
      priority: 100,
      displayName: "input.program.share",
    },
    {
      tag: "input.program.renewal",
      priority: 100,
      displayName: "input.program.renewal",
    },
    {
      tag: "input.program.datascore",
      priority: 100,
      displayName: "input.program.datascore",
    },
    {
      tag: "input.program.links",
      priority: 100,
      displayName: "input.program.links",
    },
    {
      tag: "input.program.reassured",
      priority: 100,
      displayName: "input.program.reassured",
    },
    {
      tag: "input.program.tower",
      priority: 100,
      displayName: "input.program.tower",
    },
    {
      tag: "input.program.selfInsuredRetentions",
      priority: 100,
      displayName: "input.program.selfInsuredRetentions",
    },
    {
      tag: "input.program.layerInput",
      priority: 100,
      displayName: "input.program.layerInput",
    },
    {
      tag: "input.program.notes",
      priority: 100,
      displayName: "input.program.notes",
    },
    { tag: "input.program.documentsIssued" },
    {
      tag: "input.scenarios.levelledScenarios",
      priority: 100,
      displayName: "input.scenarios.levelledScenarios",
    },
    {
      tag: "input.scenarios.valuedScenarios",
      priority: 100,
      displayName: "input.scenarios.valuedScenarios",
    },
    {
      tag: "input.scenarios.notes",
      priority: 100,
      displayName: "input.scenarios.notes",
    },
    { tag: "<Search>.transactionChip" },
    {
      tag: "<Search>.uwLocationFlagAvatar",
      displayName: "Search > Underwriter Location Flag on Card",
    },
    {
      tag: SEARCH_HELP_POPOVER,
      displayName: "Search > Help Popover",
    },
    {
      tag: SEARCH_CREATE_FROM_NO_MATCHES,
      displayName: "Search > Create Submission From No Matches",
    },
    {
      tag: "<ActiveLayerEditor>.shareOfPremium",
      priority: 100,
      displayName: "<ActiveLayerEditor>.shareOfPremium",
    },
    {
      tag: "<ActiveLayerEditor>.slip-fee",
      priority: 100,
      displayName: "<ActiveLayerEditor>.slip-fee",
    },
    { tag: "<ActiveLayerEditor>.facPct" },
    { tag: "<ActiveLayerEditor>.facPremium" },
    {
      tag: "<ActiveLayerEditor>.target-profit",
      priority: 100,
      displayName: "<ActiveLayerEditor>.target-profit",
    },
    {
      tag: "<ActiveLayerEditor>.gnulr",
      priority: 200,
      displayName: "Ark > GNULR",
    },
    {
      tag: "<ActiveLayerEditor>.reinsurance",
      priority: 200,
      displayName: "<ActiveLayerEditor>.reinsurance",
    },
    {
      tag: "<ActiveLayerEditor>.procurement",
      priority: 200,
      displayName: "<ActiveLayerEditor>.procurement",
    },
    {
      tag: "<ActiveLayerEditor>.policyType",
      priority: 200,
      displayName: "<ActiveLayerEditor>.policyType",
    },
    { tag: "<ActiveLayerEditor>.followedPolicy" },
    {
      tag: "<ActiveLayerEditor>.renewedFromLayer",
      priority: 100,
      displayName: "Renewed From Layer",
    },
    {
      tag: "<ActiveLayerEditor>.paymentTerms",
      priority: 200,
      displayName: "Helix > Payment Terms",
    },
    {
      tag: "<ActiveLayerEditor>.reference.generatePolicyNumber",
      priority: 200,
      displayName: "<ActiveLayerEditor>.reference.generatePolicyNumber",
    },
    {
      tag: "<ActiveLayerEditor>.puniReference",
      priority: 200,
    },
    {
      tag: "<ActiveLayerEditor>.externalSystemReference",
      priority: 200,
    },
    { tag: "<ActiveSubmission>.status" },
    {
      tag: "<ActiveSubmission>.copyProgramId",
      priority: 100,
      displayName: "<ActiveSubmission>.copyProgramId",
    },
    {
      tag: "<ActiveSubmission>.source",
      priority: 100,
      displayName: "<ActiveSubmission>.source",
    },
    {
      tag: "<ActiveSubmission>.activeReference",
    },
    {
      tag: "<ActiveSubmission>.reference",
    },
    {
      tag: "<ActiveSubmission>.extensionChip",
    },
    {
      tag: "pricing.modeling",
      priority: 200,
    },
    {
      tag: "pricing.lossFrequency",
      priority: 200,
      displayName: "Ark > Loss Frequency Tab",
    },
    {
      tag: "pricing.lossFrequency.notesAtTop",
      priority: 200,
      displayName: "Loss Frequency > Notes (top / bottom placement)",
    },
    { tag: "<Comparison>.peerRateChart" },
    { tag: "<Comparison>.peerIndustryClass" },
    { tag: "<Comparison>.peerNAICS" },
    { tag: "<Comparison>.peerSearch" },
    { tag: "<Comparison>.peerSelector" },
    {
      tag: "<Comparison>.peerRefreshToCurrentYear",
      displayName: "Comparison > Review > Refresh Peers to Current Year",
    },
    {
      tag: "summary.print.layers.status",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Status' Column",
    },
    {
      tag: "summary.print.layers.ourLimit",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Our Limit' Column",
    },
    {
      tag: "summary.print.layers.partOf",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Part Of' Column",
    },
    {
      tag: "summary.print.layers.excess",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Excess' Column",
    },
    {
      tag: "summary.print.layers.sir",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'SIR' Column",
    },
    {
      tag: "summary.print.layers.effectiveAttachment",
      priority: 100,
      displayName:
        "Summary Print Layer Table: Toggle 'Effective Attachment' Column",
    },
    {
      tag: "summary.print.layers.premium",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Premium' Column",
    },
    {
      tag: "summary.print.layers.rpm",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'RPM' Column",
    },
    {
      tag: "summary.print.layers.ourGross",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Our Gross' Column",
    },
    {
      tag: "summary.print.layers.ourNet",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Our Net' Column",
    },
    {
      tag: "summary.print.layers.tac",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'TAC' Column",
    },
    {
      tag: "summary.print.layers.tp",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'TP' Column",
    },
    {
      tag: "summary.print.layers.gnulr",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'GNULR' Column",
    },
    {
      tag: "summary.print.layers.brokerage",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Brokerage' Column",
    },
    {
      tag: "summary.print.layers.slipFee",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Slip Fee' Column",
    },
    {
      tag: "summary.print.layers.gelr",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'GELR' Column",
    },
    {
      tag: "summary.print.layers.rarc",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'RARC' Column",
    },
    {
      tag: "summary.print.layers.signedLine",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Signed Line %' Column",
    },
    {
      tag: "summary.print.layers.puniPremium",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Puni Premium' Column",
    },
    {
      tag: "summary.print.layers.premiumExPuni",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Premium ex Puni' Column",
    },
    {
      tag: "summary.print.layers.revenue",
      priority: 100,
      displayName: "Summary Print Layer Table: Toggle 'Revenue' Column",
    },
    {
      tag: "pricing.dnfLayerPricing",
      priority: 100,
    },

    { tag: "pricing.layerPricing.updateLossFrequency" },
    {
      tag: "pricing.layerPricing.pricingResults",
      displayName: "Layer Pricing > Pricing Results table",
    },
    {
      tag: "pricing.layerPricing.chart",
      priority: 100,
      displayName: "Layer Pricing Chart",
    },
    {
      tag: "pricing.layerPricing.baseLayer",
      priority: 100,
      displayName: "pricing.layerPricing.baseLayer",
    },
    {
      tag: "pricing.layerPricing.premiumAdjustments",
      priority: 100,
      displayName: "pricing.layerPricing.premiumAdjustments",
    },
    { tag: "pricing.layerPricing.documentsIssued" },
    {
      tag: "pricing.layerPricing.explanation",
      priority: 100,
      displayName: "Layer Pricing > UW Selected Justification",
    },
    {
      tag: "layerPricing.judgments",
      priority: 100,
      displayName: "Layer Pricing > UW Judgments",
    },
    {
      tag: "pricing.layerPricing.layerSelectorTop",
      priority: 100,
      displayName: "Layer Pricing > Layer Selector (Top)",
    },
    {
      tag: "pricing.layerPricing.layerSelectorBottom",
      priority: 100,
      displayName: "Layer Pricing > Layer Selector (Bottom)",
    },
    {
      tag: "pricing.layerPricing.productLine",
      priority: 100,
      displayName: "pricing.layerPricing.productLine",
    },
    {
      tag: "pricing.layerPricing.exposureFlags",
      priority: 100,
      displayName: "pricing.layerPricing.exposureFlags",
    },
    {
      tag: "pricing.layerPricing.percentage-sublimits",
      priority: 100,
      displayName: "Layer Pricing > Percentage Sublimits",
    },
    {
      tag: "pricing.layerPricing.proLineRetentions",
      priority: 100,
      displayName: "Layer Pricing > Pro Lines Retentions",
    },
    {
      tag: "pricing.layerPricing.nonDefaultModelWarning",
    },
    {
      tag: "claims.retentions.defaultsMismatchWarning",
      priority: 100,
      displayName: "Claims > Retentions Defaults Mismatch Warning",
    },
    {
      tag: "pricing.primaries.primariesTower",
      priority: 100,
      displayName: "pricing.primaries.primariesTower",
    },
    {
      tag: "<InsuredAverages>.update",
      priority: 100,
      displayName: "<InsuredAverages>.update",
    },
    {
      tag: "<RateChange>.justification",
      priority: 100,
      displayName: "<RateChange>.justification",
    },
    {
      tag: "<RateChange>.summaryTable",
      priority: 100,
      displayName: "<RateChange>.summaryTable",
    },
    {
      tag: "<RateChange>.oldSummaryTable",
      priority: 100,
      displayName: "<RateChange>.oldSummaryTable",
    },
    {
      tag: "<RateChange>.notes",
      priority: 100,
      displayName: "<RateChange>.notes",
    },
    {
      tag: "<RateChange>.sideBySideClaimsChart",
      priority: 100,
      displayName: "<RateChange>.sideBySideClaimsChart",
    },
    {
      tag: "<RateChange>.claimsDeltaChart",
      priority: 100,
      displayName: "<RateChange>.claimsDeltaChart",
    },
    { tag: "<RateChange>.rebase" },
    { tag: "<RateChange>.components" },
    { tag: "<RateChange>.yearOnYearExposures.usePriorYear" },
    { tag: "<RateChange>.inflation" },
    { tag: "<RateChange>.yearOnYearExposures" },
    { tag: "<RateChange>.migrateToDefaults" },
    {
      tag: "pricing.towerPricing.SIR",
      priority: 100,
      displayName: "pricing.towerPricing.SIR",
    },
    {
      tag: "pricing.towerPricing.proLineRetentions",
      priority: 100,
      displayName: "Tower Pricing > Pro Lines Retentions",
    },
    {
      tag: "pricing.towerPricing.scheduleOfUnderlying",
      priority: 100,
      displayName: "Tower Pricing > Schedule of Underlying",
    },
    {
      tag: "pricing.towerPricing.participation",
      priority: 100,
      displayName: "Tower Pricing > Participation Table",
    },
    {
      tag: "pricing.towerPricing.calculate",
      priority: 100,
      displayName: "pricing.towerPricing.calculate",
    },
    {
      tag: "pricing.towerPricing.toggleNet",
    },
    {
      tag: "pricing.copyFromExpiring",
      priority: 100,
      displayName: "Tower Pricing > Copy from Expiring Program",
    },
    { tag: "pricing.towerPricing.premiumChange" },
    { tag: "pricing.towerPricing.premiumChangePercent" },
    {
      tag: TOWER_PRICING_HIGHLIGHT_OWN_LAYERS,
      priority: 100,
      displayName: "Tower Pricing > Highlight Layers We Are On",
    },
    {
      tag: "<BrokerCreation>/name",
      priority: 99,
      displayName: "Create Broker > Name",
    },
    {
      tag: "<BrokerCreation>/email",
      priority: 99,
      displayName: "Create Broker > Email",
    },
    {
      tag: "<BrokerCreation>/workNumber",
      priority: 99,
      displayName: "Create Broker > Work Number",
    },
    {
      tag: "<BrokerCreation>/mobileNumber",
      priority: 99,
      displayName: "Create Broker > Mobile Number",
    },
    {
      tag: "<BrokerCreation>/company",
      priority: 99,
      displayName: "Create Broker > Broking House",
    },
    {
      tag: "<BrokerCreation>/address",
      priority: 99,
      displayName: "Create Broker > Address",
    },
    {
      tag: "<BrokerCreation>/location",
      priority: 99,
      displayName: "Create Broker > Location",
    },
    {
      tag: "<BrokerCreation>/licenseNumber",
      priority: 99,
      displayName: "Create Broker > License Number",
    },
    {
      tag: "<BrokerCreation>/npn",
      priority: 99,
      displayName: "Create Broker > NPN",
    },
    {
      tag: "pricing.towerPricing.asIfLayer",
      priority: 100,
      displayName: "pricing.towerPricing.asIfLayer",
    },
    { tag: "pricing.towerPricing.share.shareOfLimit" },
    { tag: "pricing.towerPricing.share.share" },
    { tag: "pricing.towerPricing.share.shareOfGwp" },
    { tag: "pricing.towerPricing.share.brokerage" },
    { tag: "pricing.towerPricing.share.shareOfNwp" },
    { tag: "pricing.towerPricing.share.comments" },
    { tag: "pricing.towerPricing.share.reference" },
    { tag: "pricing.towerPricing.comments" },
    { tag: "pricing.towerPricing.copyLayer" },
    { tag: "pricing.towerPricing.share.coverage" },
    { tag: "pricing.towerPricing.share.policyForm" },
    { tag: "pricing.towerPricing.share.aggregateLimit" },
    { tag: "pricing.towerPricing.share.plAggregateLimit" },
    { tag: "summary.peerReview.peerReviewer" },
    { tag: "summary.peerReview.attendees" },
    {
      tag: "summary.peerReview.me-reviewer",
      priority: 100,
      displayName: "summary.peerReview.me-reviewer",
    },
    {
      tag: "summary.notes.peerReview.email",
      priority: 100,
      displayName: "summary.notes.peerReview.email",
    },
    {
      tag: "summary.notes.peerReview.complete",
      priority: 100,
      displayName: "summary.notes.peerReview.complete",
    },
    {
      tag: "summary.notes.peerReview",
      priority: 100,
      displayName: "summary.notes.peerReview",
    },
    {
      tag: "<Print>.peerReview",
      priority: 100,
      displayName: "<Print>.peerReview",
    },
    {
      tag: "<Print>.claimsCharts",
      priority: 100,
      displayName: "<Print>.claimsCharts",
    },
    {
      tag: "<Print>.lossesByCoverageChart",
      priority: 100,
      displayName: "<Print>.lossesByCoverageChart",
    },
    {
      tag: "<Print>.topClaims",
      priority: 100,
      displayName: "<Print>.topClaims",
    },
    {
      tag: "<Print>.lossFrequencyChart",
      priority: 100,
      displayName: "<Print>.lossFrequencyChart",
    },
    {
      tag: "<Print>.links",
      priority: 100,
      displayName: "<Print>.links",
    },
    {
      tag: "<Print>.insuredLogo",
      priority: 100,
      displayName: "<Print>.insuredLogo",
    },
    {
      tag: "<Print>.tower",
      priority: 100,
      displayName: "<Print>.tower",
    },
    {
      tag: "<Print>.peerPricing",
      priority: 100,
      displayName: "<Print>.peerPricing",
    },
    { tag: "<Print>.summary.priorGwp" },
    { tag: "<Print>.uwJudgments" },
    { tag: "<Print>.exposureFlags" },
    { tag: "<Print>.regulatoryExemptions" },
    { tag: "<Print>.meta.reference" },
    { tag: "<Print>.meta.inception" },
    { tag: "<Print>.meta.renewal" },
    { tag: "<Print>.meta.industryClass" },
    { tag: "<Print>.meta.preferredUnderwriter" },
    { tag: "<Print>.meta.brokerage" },
    { tag: "<Print>.meta.broker" },
    { tag: "<Print>.meta.brokerAddress" },
    { tag: "<Print>.meta.insuredAddress" },
    { tag: "<Print>.aggregatedClaimsTable" },
    { tag: "<Print>.currentExposures" },
    { tag: "<Print>.recentExposures" },
    { tag: "<Print>.structure" },
    { tag: "<Print>.rateAdequacy" },
    { tag: "<Print>.targetLossRatios" },
    {
      tag: "input.program",
      priority: 440,
      displayName: "Tab > Input > Program",
    },
    {
      tag: "input.brokerTower",
      priority: 440,
      displayName: "Tab > Input > Broker Tower",
    },
    { tag: "input.claims", priority: 440, displayName: "Tab > Input > Claims" },
    { tag: "input.sic", priority: 440, displayName: "Tab > Input > SIC" },
    {
      tag: "input.prem-deduct",
      priority: 440,
      displayName: "Tab > Input > Premium Deduction",
    },
    {
      tag: "input.sov",
      priority: 440,
      displayName: "Tab > Input > SOV",
    },
    {
      tag: "input.property-sov",
      priority: 440,
    },
    {
      tag: "input.sov.heatmap.warning",
      priority: 440,
      displayName: "Tab > Input > Risk Exposures > SOV > Heatmap > Warning",
    },
    {
      tag: "input.loss-development",
      priority: 440,
      displayName: "Tab > Input > Loss Development",
    },
    {
      tag: "input.loss-development.notes",
      priority: 440,
      displayName: "Tab > Input > Loss Development > Notes",
    },
    {
      tag: "input.loss-development.targetLossRatios",
      priority: 440,
      displayName: "Tab > Input > Loss Development > Target Loss Ratios",
    },
    {
      tag: "input.exposure",
      priority: 440,
      displayName: "Tab > Input > Exposure",
    },
    { tag: "input.flags", priority: 440, displayName: "Tab > Input > Flags" },
    {
      tag: "input.flags.uwJudgement",
      priority: 440,
      displayName: "Tab > Input > Flags > UW Judgements",
    },
    {
      tag: "input.flags.autocompleteDefaultJudgments",
      priority: 100,
      displayName: "Input > Flags > Autocomplete Default Judgments",
    },
    {
      tag: "input.flags.exposureFlags",
      priority: 440,
      displayName: "Tab > Input > Flags > Exposure Falgs",
    },
    {
      tag: "input.flags.stateLaw",
      priority: 440,
      displayName: "Tab > Input > Flags > State Law",
    },
    {
      tag: COVERAGE_NOTES,
      priority: 100,
      displayName: "Coverage Notes (Flags + Summary)",
    },
    {
      tag: "input.scenarios",
      priority: 440,
      displayName: "Tab > Input > Scenarios",
    },
    {
      tag: "input.attachments",
      priority: 440,
      displayName: "Tab > Input > Attachments",
    },
    {
      tag: "input.sidecar",
      priority: 440,
      displayName: "Tab > Input > Sidecar",
    },
    {
      tag: "input.surplus-lines-tax",
      priority: 440,
      displayName: "Tab > Input > Surplus Lines Tax",
    },
    {
      tag: "input.surplus-lines-tax.stateOfFiling",
      priority: 440,
      displayName: "Tab > Input > Surplus Lines Tax > State of Filing",
    },
    {
      tag: "input.pricing_assumptions",
      priority: 440,
      displayName: "Tab > Input > Pricing Assumptions",
    },
    {
      tag: "<AppMenu>/token",
      priority: 999,
      displayName: "App Menu > Token",
    },
    {
      tag: "<AppMenu>/forms",
      priority: 999,
      displayName: "App Menu > Forms",
    },
    {
      tag: "<AppMenu>/scenarios",
      priority: 999,
      displayName: "App Menu > Scenarios",
    },
    {
      tag: "<AppMenu>/reports",
      priority: 998,
      displayName: "App Menu > Reports",
    },
    {
      tag: "<AppMenu>/report-builder",
      priority: 998,
      displayName: "App Menu > Report Builder",
    },
    {
      tag: "<AppMenu>/programs/cause",
      priority: 998,
      displayName: "App Menu > Programs > CAUSE",
    },
    {
      tag: "<AppMenu>/triage-pipeline",
      priority: 998,
      displayName: "App Menu > Triage Pipeline",
    },
    {
      tag: "<AppMenu>/templates",
      priority: 998,
      displayName: "App Menu > Templates",
    },
    { tag: "inputs", priority: 800, displayName: "Section > Inputs" },
    { tag: "pricing", priority: 800, displayName: "Section > Pricing" },
    { tag: "comparison", priority: 800, displayName: "Section > Comparison" },
    { tag: "summary", priority: 800, displayName: "Section > Summary" },
    {
      tag: "comparison.review",
      priority: 432,
      displayName: "Tab > Comparison > Review",
    },
    {
      tag: "comparison.group",
      priority: 431,
      displayName: "Tab > Comparison > Group",
    },
    {
      tag: "comparison.exposure",
      priority: 430,
      displayName: "Tab > Comparison > Exposure",
    },
    {
      tag: "comparison.tower",
      priority: 430,
      displayName: "Tab > Comparison > Tower Rate Chart",
    },
    {
      tag: "pricing.tailAnalysis",
      priority: 420,
      displayName: "Tab > Pricing > Tail Analysis",
    },
    {
      tag: "pricing.claimsSelector",
      priority: 420,
      displayName: "Tab > Pricing > Claims Selector",
    },
    {
      tag: "pricing.lossFrequency",
      priority: 420,
      displayName: "Tab > Pricing > Loss Frequency",
    },
    {
      tag: "pricing.burningCost",
      priority: 420,
      displayName: "Tab > Pricing > Burning Cost",
    },
    {
      tag: "pricing.baseLayerBurn",
      priority: 420,
      displayName: "Tab > Pricing > Base Layer Burn",
    },
    {
      tag: "pricing.glPricing",
      priority: 420,
      displayName: "Tab > Pricing > GL Pricing",
    },
    {
      // gates every workbook-driven pricing model tab from the pricing_models registry
      tag: SPREADSHEET_BASED_PRICING,
      priority: 420,
      displayName: "Tab > Pricing > Spreadsheet Based Pricing",
    },
    {
      tag: GL_PRICING_CLASSIFICATIONS,
      displayName: "GL Pricing Classifications",
    },
    {
      tag: "pricing.autoPricing",
      priority: 420,
      displayName: "Tab > Pricing > Auto Pricing",
    },
    {
      tag: "pricing.lossRating",
      priority: 420,
      displayName: "Tab > Pricing > Loss Rating",
    },
    {
      tag: PRICING_XS_RATING,
      priority: 420,
      displayName: "Tab > Pricing > XS Rating",
    },
    {
      tag: "pricing.layerPricing",
      priority: 420,
      displayName: "Tab > Pricing > Layer Pricing",
    },
    {
      tag: "pricing.towerPricing",
      priority: 420,
      displayName: "Tab > Pricing > Tower Pricing",
    },
    {
      tag: "pricing.expiringProgram",
      priority: 420,
      displayName: "Tab > Pricing > Expiring Program",
    },
    {
      tag: "pricing.ultimate",
      priority: 420,
      displayName: "Tab > Pricing > Ultimate",
    },
    {
      tag: "pricing.rateChange",
      priority: 420,
      displayName: "Tab > Pricing > Rate Change",
    },
    {
      tag: "pricing.rateAdequacy",
      priority: 420,
      displayName: "Tab > Pricing > Rate Adequacy",
    },
    {
      tag: "pricing.renewalRateChange",
      priority: 420,
      displayName: "Tab > Pricing > Renewal Rate Change",
    },
    {
      tag: "pricing.renewalRateChange.portfolio",
      priority: 420,
      displayName:
        "Tab > Pricing > Renewal Rate Change > Include/Exclude in Portfolio",
    },
    {
      tag: "pricing.claimsSelector.includedLossTypes",
      priority: 100,
      displayName: "Pricing > Claims Selector > Included Loss Types",
    },
    {
      tag: "pricing.towerPricing.addLayer",
      priority: 100,
      displayName: "Tower Pricing Table > Add Layer",
    },
    {
      tag: "pricing.towerPricing.deleteLayer",
      priority: 100,
      displayName: "Tower Pricing Table > Delete Layer",
    },
    {
      tag: "pricing.towerPricing.index",
      priority: 100,
      displayName: "Tower Pricing Table > Index",
    },
    {
      tag: "pricing.towerPricing.carrier",
      priority: 100,
      displayName: "Tower Pricing Table > Carrier",
    },
    {
      tag: "pricing.towerPricing.expandShare",
      priority: 100,
      displayName: "Tower Pricing Table > Expand Share",
    },
    {
      tag: "pricing.towerPricing.tertile",
      priority: 100,
      displayName: "Tower Pricing Table > Tertile",
    },
    {
      tag: "pricing.towerPricing.limit",
      priority: 100,
      displayName: "Tower Pricing Table > Limit",
    },
    {
      tag: "pricing.towerPricing.calculateError",
      priority: 100,
      displayName: "Tower Pricing Table > Calculate Error",
    },
    {
      tag: "pricing.towerPricing.attachment",
      priority: 100,
      displayName: "Tower Pricing Table > Attachment",
    },
    {
      tag: "pricing.towerPricing.includeSir",
      priority: 100,
      displayName: "Tower Pricing Table > Include SIR",
    },
    {
      tag: "pricing.towerPricing.effectiveAttachment",
      priority: 100,
      displayName: "Tower Pricing Table > Effective Attachment",
    },
    {
      tag: "pricing.towerPricing.grossPremium",
      priority: 100,
      displayName: "Tower Pricing Table > Gross Premium",
    },
    {
      tag: "pricing.towerPricing.brokerage",
      priority: 100,
      displayName: "Tower Pricing Table > Brokerage",
    },
    {
      tag: "pricing.towerPricing.netPremium",
      priority: 100,
      displayName: "Tower Pricing Table > Net Premium",
    },
    {
      tag: "pricing.towerPricing.grossRPM",
      priority: 100,
      displayName: "Tower Pricing Table > Gross RPM",
    },
    {
      tag: "pricing.towerPricing.netRPM",
      priority: 100,
      displayName: "Tower Pricing Table > Net RPM",
    },
    {
      tag: "pricing.towerPricing.grossAsIfRPM",
      priority: 100,
      displayName: "Tower Pricing Table > Gross As If RPM",
    },
    {
      tag: "pricing.towerPricing.grossAsIfTP",
      priority: 100,
      displayName: "Tower Pricing Table > Gross As If TP",
    },
    {
      tag: "pricing.towerPricing.selectLayer",
      priority: 100,
      displayName: "Tower Pricing Table > Select Layer",
    },
    {
      tag: "pricing.towerPricing.grossSelectedRPM",
      priority: 100,
      displayName: "Tower Pricing Table > Gross Selected RPM",
    },
    {
      tag: "pricing.towerPricing.netSelectedRPM",
      priority: 100,
      displayName: "Tower Pricing Table > Net Selected RPM",
    },
    {
      tag: "pricing.towerPricing.grossSelectedMargin",
      priority: 100,
      displayName: "Tower Pricing Table > Gross Selected Margin",
    },
    {
      tag: "pricing.towerPricing.grossModelledMargin",
      priority: 100,
      displayName: "Tower Pricing Table > Gross Modelled Margin",
    },
    {
      tag: "pricing.towerPricing.grossRelativeRate",
      priority: 100,
      displayName: "Tower Pricing Table > Gross Relative Rate",
    },
    {
      tag: "pricing.towerPricing.netRelativeRate",
      priority: 100,
      displayName: "Tower Pricing Table > Net Relative Rate",
    },
    { tag: "pricing.towerPricing.inception" },
    { tag: "pricing.towerPricing.expiration" },
    {
      tag: "pricing.towerPricing.futureTarget",
      priority: 100,
      displayName: "Tower Pricing Table > Future Target",
    },
    {
      tag: "summary.program",
      priority: 410,
      displayName: "Tab > Summary > Program",
    },
    {
      tag: "summary.notes",
      priority: 410,
      displayName: "Tab > Summary > Notes",
    },
    {
      tag: "summary.snapshots",
      priority: 410,
      displayName: "Tab > Summary > Snapshots",
    },
    {
      tag: "summary.templates",
      priority: 410,
      displayName: "Tab > Summary > Templates",
    },
    {
      tag: "summary.payments",
      priority: 410,
      displayName: "Tab > Summary > Payments",
    },
    { tag: "summary.allocations" },
    { tag: "<Submission>.duplicate" },
    {
      tag: "<Submission>.comments",
      priority: 500,
      displayName: "<Submission>.comments",
    },
    { tag: "<Submission>.allocation" },
    { tag: "<Submission>.meetingNotes" },
    { tag: "<Submission>.research" },
    {
      tag: "<Print>.tower.tower",
      priority: 100,
      displayName: "<Print>.tower.tower",
    },
    {
      tag: "<Print>.tower.diagram",
      priority: 100,
      displayName: "<Print>.tower.diagram",
    },
    {
      tag: "<Print>.tower.pricing",
      priority: 100,
      displayName: "<Print>.tower.pricing",
    },
    {
      tag: NOT_SAVED_INTER_PAGE_WARNING,
      priority: 100,
      displayName: NOT_SAVED_INTER_PAGE_WARNING,
    },
    {
      tag: NOT_SAVED_APP_EXIT_WARNING,
      priority: 100,
      displayName: NOT_SAVED_APP_EXIT_WARNING,
    },
    {
      tag: CREATE_CLAIMS_COVERAGE_LIST,
      priority: 100,
      displayName: CREATE_CLAIMS_COVERAGE_LIST,
    },
    {
      tag: APP_BAR_ISSUE_FEEDBACK_IN_MENU,
      priority: 100,
      displayName: APP_BAR_ISSUE_FEEDBACK_IN_MENU,
    },
    {
      tag: APP_BAR_ISSUE_FEEDBACK_BUTTON,
      priority: 100,
      displayName: APP_BAR_ISSUE_FEEDBACK_BUTTON,
    },
    {
      tag: SUB_STAT_REPORT_SHOW_LAYER_REFERNCE,
      priority: 100,
      displayName: SUB_STAT_REPORT_SHOW_LAYER_REFERNCE,
    },
    {
      tag: SUB_STAT_REPORT_SHOW_PROGRAM_REFERENCE,
      priority: 100,
      displayName: SUB_STAT_REPORT_SHOW_PROGRAM_REFERENCE,
    },
    {
      tag: "input.sov.template.download.button",
      priority: 100,
      displayName: "Tab > Input > SOV > Template Download Button",
    },
    {
      tag: "input.sov.validateForLayer",
      priority: 100,
      displayName: "Tab > Input > SOV > Validate for Layer",
    },
    {
      tag: SOV_DOWNLOAD_BUTTON_ENABLED,
      priority: 100,
      displayName: SOV_DOWNLOAD_BUTTON_ENABLED,
    },
    {
      tag: INCLUDE_AGGREGATE_LOSS_BY_LINE,
    },
    {
      tag: "pricing.dnfLayerPricing.policyForm",
      priority: 100,
      displayName: "DnF Layer Summary Policy Form",
    },
    {
      tag: "pricing.dnfLayerPricing.topLocTIVPercentage",
      priority: 100,
      displayName: "DnF Layer Summary Status Selector",
    },
    {
      tag: "pricing.dnfLayerPricing.statusSelector",
      priority: 100,
      displayName: "DnF Layer Summary Status Selector",
    },
    { tag: "<BaseLayerBurn>.scalingExposure" },
    { tag: "<BaseLayerBurn>.lossesByYear" },
    {
      tag: "pricing.baseLayerBurn.justification",
      priority: 100,
      displayName: "Base Layer Burn > Selected Price Justification",
    },
    { tag: "<BaseLayerBurn>.pricingTable.simpleBurn" },
    { tag: "<BaseLayerBurn>.pricingTable.lossPerUnitExposure" },
    { tag: "<BaseLayerBurn>.pricingTable.exposureScaledBurn" },
    { tag: "<BaseLayerBurn>.pricingTable.selectedPrice" },
    { tag: "<DnfLayerPricing>.inputs" },
    { tag: "<DnfLayerPricing>.additionalInputs" },
    { tag: "<DnfLayerPricing>.pricingLoads.growth" },
    { tag: "<DnfLayerPricing>.layerPricing.menu" },
    { tag: "<DnfLayerPricing>.layerPricing.followedPolicy" },
    {
      tag: "<SnapshotPricing>.excess",
      displayName: "Snapshot Pricing > Excess Column",
    },
    {
      tag: "<SnapshotPricing>.gnulr",
      displayName: "Snapshot Pricing > GNULR Column",
    },
    {
      tag: "<SnapshotPricing>.ourGross",
      displayName: "Snapshot Pricing > Our Gross Column",
    },
    {
      tag: "<SnapshotPricing>.ourLimit",
      displayName: "Snapshot Pricing > Our Limit Column",
    },
    {
      tag: "<SnapshotPricing>.ourNet",
      displayName: "Snapshot Pricing > Our Net Column",
    },
    {
      tag: "<SnapshotPricing>.partOf",
      displayName: "Snapshot Pricing > Part Of Column",
    },
    {
      tag: "<SnapshotPricing>.premium",
      displayName: "Snapshot Pricing > Premium Column",
    },
    {
      tag: "<SnapshotPricing>.rpm",
      displayName: "Snapshot Pricing > RPM Column",
    },
    {
      tag: "<SnapshotPricing>.status",
      displayName: "Snapshot Pricing > Status Column",
    },
    {
      tag: "<SnapshotPricing>.tac",
      displayName: "Snapshot Pricing > TAC Column",
    },
    {
      tag: "<SnapshotPricing>.targetPrice",
      displayName: "Snapshot Pricing > Target Price Column",
    },
    {
      tag: "pricing.forestryLayerPricing",
      displayName: "Forestry Layer Pricing",
    },
    {
      tag: "pricing.iabLayerPricing",
      displayName: "IAB Layer Pricing",
    },
    {
      tag: "<ForestryLayerPricing>.inputs",
      displayName: "Forestry Layer Pricing > Inputs",
    },
    {
      tag: "<ForestryLayerPricing>.additionalInputs",
      displayName: "Forestry Layer Pricing > Additional Inputs",
    },
    {
      tag: "<ForestryLayerPricing>.layerPricing.menu",
      displayName: "Forestry Layer Pricing > Extra Menu",
    },
    {
      tag: "<ForestryLayerPricing>.layerPricing.policyForm",
      priority: 100,
      displayName: "Forestry Layer Pricing > Policy Form",
    },
    {
      tag: "<ForestryLayerPricing>.layerPricing.topLocTIVPercentage",
      priority: 100,
      displayName: "Forestry Layer Pricing > Top Location TIV Percentage",
    },
    {
      tag: "<ForestryLayerPricing>.layerPricing.statusSelector",
      priority: 100,
      displayName: "Forestry Layer Pricing > Status Selector",
    },
    {
      tag: "pricing.autoLayerPricing",
      displayName: "Auto Layer Pricing",
    },
    {
      tag: "<AutoLayerPricing>.inputs",
      displayName: "Auto Layer Pricing > Inputs",
    },
    {
      tag: "<AutoLayerPricing>.additionalInputs",
      displayName: "Auto Layer Pricing > Additional Inputs",
    },
    {
      tag: "<AutoLayerPricing>.layerPricing.menu",
      displayName: "Auto Layer Pricing > Extra Menu",
    },
    {
      tag: "<AutoLayerPricing>.layerPricing.policyForm",
      priority: 100,
      displayName: "Auto Layer Pricing > Policy Form",
    },
    {
      tag: "<AutoLayerPricing>.layerPricing.statusSelector",
      priority: 100,
      displayName: "Auto Layer Pricing > Status Selector",
    },
    { tag: "inputs.brokerTower.SIR" },
    { tag: "inputs.brokerTower.towerNote" },
    { tag: "inputs.brokerTower.towerRateChart" },
    { tag: "inputs.brokerTower.participationTable" },
    { tag: "<BrokerTower>.toggleNet" },
    { tag: "<BrokerTower>.table.addLayer" },
    { tag: "<BrokerTower>.table.deleteLayer" },
    { tag: "<BrokerTower>.table.index" },
    { tag: "<BrokerTower>.table.carrier" },
    { tag: "<BrokerTower>.table.expandShare" },
    { tag: "<BrokerTower>.table.limit" },
    { tag: "<BrokerTower>.table.attachment" },
    { tag: "<BrokerTower>.table.includeSir" },
    { tag: "<BrokerTower>.table.effectiveAttachment" },
    { tag: "<BrokerTower>.table.grossPremium" },
    { tag: "<BrokerTower>.table.premiumChange" },
    { tag: "<BrokerTower>.table.premiumChangePercent" },
    { tag: "<BrokerTower>.table.brokerage" },
    { tag: "<BrokerTower>.table.netPremium" },
    { tag: "<BrokerTower>.table.grossRPM" },
    { tag: "<BrokerTower>.table.netRPM" },
    { tag: "<BrokerTower>.table.grossRelativeRate" },
    { tag: "<BrokerTower>.table.netRelativeRate" },
    { tag: "<BrokerTower>.table.share.coverage" },
    { tag: "<BrokerTower>.table.share.shareOfLimit" },
    { tag: "<BrokerTower>.table.share.shareOfLimit.showErrors" },
    { tag: "<BrokerTower>.table.share.share" },
    { tag: "<BrokerTower>.table.share.shareOfGwp" },
    { tag: "<BrokerTower>.table.share.shareOfGwp.showErrors" },
    { tag: "<BrokerTower>.table.share.grossRPM" },
    { tag: "<BrokerTower>.table.share.brokerage" },
    { tag: "<BrokerTower>.table.share.shareOfNwp" },
    { tag: "<BrokerTower>.table.share.retroactiveDate" },
    { tag: "<BrokerTower>.table.share.policyForm" },
    { tag: "<BrokerTower>.table.share.aggregateLimit" },
    { tag: "<BrokerTower>.table.share.plAggregateLimit" },
    { tag: "<BrokerTower>.table.share.comments" },
    { tag: "<BrokerTower>.table.share.reference" },
    { tag: RENEWAL_FILTER_IS_VISIBLE },
    { tag: DISPLAY_TEMPLATES_SUMMARY_BUTTON },
    { tag: SOV_GRID_COPY_CELLS_ENABLED },
    {
      tag: TOWER_PRICING_SIR_COPY_ENABLED,
      displayName: "Tower Pricing Table > Include SIR > Copy to All",
    },
    { tag: PROGRAM_UNDERWRITER_ASSISTANT },
    {
      tag: "<SpecialAcceptance>.riCessionException",
      displayName: "Special Acceptance > RI Cession Exception",
    },
    {
      tag: "settings.industry-class",
      displayName: "Settings > Industry Class",
    },
    {
      tag: "settings.exposures",
      displayName: "Settings > Exposures",
    },
    {
      tag: "settings.underwriters",
      displayName: "Settings > Underwriters",
    },
    {
      tag: "settings.people",
      displayName: "Settings > People",
    },
    {
      tag: "settings.feedback",
      displayName: "Settings > Feedback",
    },
    {
      tag: "settings.scorecard-plan",
      displayName: "Settings > Scorecard Plan",
    },
    {
      tag: REPORTS_V3_ALLOW_MULTI_TABLE_REPORTS,
    },
    {
      tag: REPORTS_V3_ALLOW_IMPORT_EXPORT,
    },
    {
      tag: REPORTS_V3_ALLOW_AS_AT,
      displayName: "Reports V3 > As At Date",
    },
    {
      tag: REPORTS_V3_REVIEW_SCORECARD,
      displayName: "Reports V3 > Review Scorecard",
    },
    {
      tag: POLICY_MANAGER,
      displayName: "Templates > Policy Manager",
    },
    {
      tag: TEMPLATE_REQUESTS_EDIT_FLOW_V2,
      displayName: "Templates > Template Request Edit Flow V2",
    },
    {
      tag: "templateRequests.libreofficePreview",
      displayName: "Templates > LibreOffice Server-Side Preview",
    },
    {
      tag: "feedback.priority",
    },
  ],
  feature: [
    {
      flag: "claims/applyFxRates",
      displayName: "claims/applyFxRates",
      created: "2024-04-01",
    },
    {
      flag: REVIEW_REPORTS_SHOW_ALL_VALUES_IN_FILTERS,
      created: "2024-05-07",
      displayName: REVIEW_REPORTS_SHOW_ALL_VALUES_IN_FILTERS,
    },
    {
      flag: DYNAMIC_AUTO_COMPLETE,
      created: "2024-06-19",
    },
    {
      flag: "files/disableOleObjectExtraction",
      created: "2024-06-20",
    },
    {
      flag: "ui/disableSchemaVersionValidation",
      created: "2024-06-19",
    },
    {
      flag: "ui/submissionReloadOnSave",
      created: "2024-09-20",
    },
    {
      flag: "ui/pasteExposureRow",
      created: "2024-10-09",
    },
    {
      flag: "ui/enableEditOfClaimsOpenClosed",
      created: "2024-10-10",
    },
    {
      flag: "ui/disableSpellcheck",
      created: "2024-11-27",
    },
    {
      flag: "security-manage-visibility-by-role",
      created: "2025-01-08",
    },
    {
      flag: "summary/notes/showAllNotes",
      created: "2025-03-19",
    },
    {
      flag: "allow-use-of-lambdas-in-get-status-tree",
      created: "2025-03-24",
    },
    {
      flag: "reject-embedded-files-that-have-no-name",
      created: "2025-03-27",
    },
    {
      flag: "show-layer-pricing-errors-inline",
      created: "2025-04-26",
    },
    {
      flag: "use-renewal-grouping-in-search",
      displayName: "Search > Group Submissions by Renewal History",
      created: "2025-09-03",
    },
    {
      flag: USE_AI_AGENTS_COLUMN_MAPPING,
      displayName: "Use AI Agents for Column Mapping Suggestions",
      created: "2025-01-13",
    },
    {
      flag: USE_CLAIMS_AI_PARSING,
      displayName: "Use AI Parsing for Claims Data",
      created: "2025-01-13",
    },
    {
      flag: USE_STREAMING_FOR_CLAIMS_AI_PARSING,
      displayName: "Use Streaming for Claims AI Parsing",
      created: "2025-01-13",
    },
    {
      flag: AI_PDF_EXTRACTION,
      displayName: "AI PDF Extraction for Claims",
      created: "2025-01-14",
    },
    {
      flag: AI_CLAIMS_MATCH,
      displayName: "AI Claims Matching",
      created: "2025-10-09",
    },
    {
      flag: RUN_AI_CLAIMS_MATCH_ON_LOAD,
      displayName: "Auto-run AI Claims Matching on Load",
      created: "2025-10-09",
    },
    {
      flag: AI_CLAIMS_DUPLICATE_DETECTION,
      displayName: "AI Claims Duplicate Detection",
      created: "2025-10-24",
    },
    {
      flag: AI_PDF_VIEWER_ALLOW_EXCEL_DOWNLOADS,
      displayName: "AI PDF Viewer: Allow Excel Downloads",
      created: "2025-11-19",
    },
    {
      flag: "ui/rateChangeSelectorIncludeSIR",
      created: "2025-07-08",
    },
    {
      flag: "claims/bucketAggregatedClaimsByPolicyYear",
      created: "2025-07-10",
    },
    {
      flag: "use-improved-renewal-ui",
      created: "2025-08-07",
    },
    {
      flag: "ui/showProRataAdjustmentsInLayerPricing",
      created: "2025-07-10",
    },
    {
      flag: USE_PRO_RATA_ADD_RETURN_CALCULATOR,
      created: "2025-10-06",
    },
    {
      flag: "continue-to-use-parquet-files-configuration",
      created: "2025-10-20",
    },
    {
      flag: PRICING_ENABLE_SPLIT_UW_LOAD,
      created: "2025-11-14",
    },
    {
      flag: USE_PING_SOV_EXTRACTION,
      displayName: "Use PingIntel SOV Extraction",
      created: "2025-11-13",
    },
    {
      flag: "read-only-user-whitelisting-of-reports",
      created: "2025-12-19",
    },
    {
      flag: "reports_v3-default-report-all-users",
      created: "2025-12-19",
    },
    {
      flag: "submission-search-emoji-tags",
      displayName: "Search > Emoji Tags for Submissions",
      created: "2026-01-27",
    },
    {
      flag: TOWER_SIR_SUMMARY_DISPLAY,
      displayName: "Tower > SIR Display on Summary",
      created: "2026-02-17",
    },
    {
      flag: SUMMARY_PRICING_RESULTS_TOGGLE,
      displayName: "Summary > Pricing Results Toggle",
      created: "2026-02-17",
    },
    {
      flag: INSURED_ADDRESS_AUTO_PARSE,
      displayName: "Program > Insured Address Auto-Parse",
      created: "2026-03-14",
    },
    {
      flag: SIC_CODE_INDUSTRY_SUGGESTION,
      displayName: "Program > SIC Code Industry Class Suggestion",
      created: "2026-03-14",
    },
    {
      flag: LEGACY_THEME,
      displayName: "Legacy Colour Theme",
      created: "2026-03-15",
    },
    {
      flag: ENDORSEMENT_ALLOW_SKIP_COUNT,
      created: "2026-04-15",
    },
    {
      flag: SHOW_AI_FILE_SELECTION_LABELS,
      displayName: "Submission Drawer > Show AI File Selection Labels",
      created: "2026-04-27",
    },
    {
      flag: ENABLE_AGGREGATE_COLUMN_GENERATION,
      created: "2026-04-20",
    },
    {
      flag: AUTO_STATUS_ON_DOCUMENT_ISSUE,
      created: "2026-05-26",
    },
    {
      flag: TEMPLATE_OVERRIDE_ALLOW_PDF,
      displayName: "Templates > Allow PDF Template Overrides",
      created: "2026-06-16",
    },
    {
      flag: TEMPLATES_DOWNLOAD_FILLED_WORD_DOCUMENT,
      displayName: "Templates > Download Filled Word Document",
      created: "2026-07-16",
    },
    {
      flag: LAYER_PRICING_COMPACT_LAYOUT,
      displayName:
        "Layer Pricing > Compact Layout (Layers + Adjustments in right column)",
      created: "2026-05-27",
    },
  ],
};

export default flags;
